import { render } from "./PrintingSystemMdal.vue?vue&type=template&id=51a8a2fa&ts=true"
import script from "./PrintingSystemMdal.vue?vue&type=script&lang=ts"
export * from "./PrintingSystemMdal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__